(ns frontend.ui.component.lp-portal.report.module.chart-card
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.chart.view :as chart]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn view
  [title data props]
  [card/card
   {:title title}
   [:<>
    [chart/chart data props]
    (when-not (:hide-footnote? props) (text-content/optional-footnote data props))]])

(defn row-view
  [title data props]
  [:div
   {}
   [view title data props]])
